export default "__VITE_ASSET__pK3ymbGT__"